import ChipTicketType, {
    type StatusChipProps,
} from '@/components/chip/ChipTicketTypeStatus';
import { TicketTypeEnum } from '@/types/enums/ticket-type.enum';

type TicketTypeData = {
    label: string;
    color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';
    colorHex: string;
};

export const getTicketTypeData = (props: StatusChipProps): TicketTypeData => {
    return ChipTicketType({
        ...props,
        showChip: false,
    }) as TicketTypeData;
};

export const getTicketTypeOptionsFilter = (isFilter?: boolean) => {
    const enumValues = TicketTypeEnum;

    const options: any[] = [];

    (
        Object.entries(enumValues) as [
            keyof typeof enumValues,
            (typeof enumValues)[keyof typeof enumValues],
        ][]
    ).forEach(([key, value]) => {
        const data = getTicketTypeData({
            status: value as TicketTypeEnum,
        });

        options.push({
            id: value,
            value: !isFilter ? value : String(key).toUpperCase(),
            title: data.label,
            label: data.label,
            color: data.colorHex,
        });
    });

    return options;
};
